import { render, staticRenderFns } from "./ZhiZhuPay.vue?vue&type=template&id=07ee4755"
import script from "./ZhiZhuPay.vue?vue&type=script&lang=js"
export * from "./ZhiZhuPay.vue?vue&type=script&lang=js"
import style0 from "./ZhiZhuPay.vue?vue&type=style&index=0&id=07ee4755&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports